import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export const CTAButton = ({
  children,
  href = '#pricing',
  className = '',
  fullWidth = false
}: {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}) => <motion.a href={href} whileHover={{
  scale: 1.05
}} whileTap={{
  scale: 0.95
}} className={`inline-block bg-gradient-to-r from-coral to-rosegold text-white font-heading font-bold text-base md:text-xl py-3 md:py-4 px-6 md:px-8 rounded-full shadow-lg hover:shadow-xl transition-all text-center ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-309">
    {children}
  </motion.a>;
export const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState(86210);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <div className="flex items-center justify-center space-x-2 text-xl md:text-4xl font-heading font-bold text-charcoal my-3 md:my-4" data-id="element-310">
      <div className="bg-white px-2 md:px-3 py-1.5 md:py-2 rounded-lg shadow-md min-w-[48px] md:min-w-[60px] text-center" data-id="element-311">
        {hours.toString().padStart(2, '0')}
      </div>
      <span className="text-coral" data-id="element-312">:</span>
      <div className="bg-white px-2 md:px-3 py-1.5 md:py-2 rounded-lg shadow-md min-w-[48px] md:min-w-[60px] text-center" data-id="element-313">
        {minutes.toString().padStart(2, '0')}
      </div>
      <span className="text-coral" data-id="element-314">:</span>
      <div className="bg-white px-2 md:px-3 py-1.5 md:py-2 rounded-lg shadow-md min-w-[48px] md:min-w-[60px] text-center text-coral" data-id="element-315">
        {seconds.toString().padStart(2, '0')}
      </div>
    </div>;
};
export const Section = ({
  children,
  className = '',
  id = '',
  bg = 'white'
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
  bg?: 'white' | 'cream' | 'charcoal';
}) => {
  const bgColors = {
    white: 'bg-white',
    cream: 'bg-cream',
    charcoal: 'bg-charcoal text-white'
  };
  return <section id={id} className={`py-6 md:py-24 px-3 md:px-8 overflow-hidden ${bgColors[bg]} ${className}`} data-id="element-316">
      <div className="max-w-6xl mx-auto" data-id="element-317">{children}</div>
    </section>;
};
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => <motion.div initial={{
  opacity: 0,
  y: 30
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-50px'
}} transition={{
  duration: 0.6,
  delay
}} className={className} data-id="element-318">
    {children}
  </motion.div>;